import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-download-document',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
  <div class="download-button">
  <a class="download-document-link"
  [href]="url"><mat-icon class="download-icon">file_download</mat-icon></a>
  </div>
`
})
export class DownloadDocumentComponent implements OnInit {

  id: any;
  url = '';

  @Input() set data(data: any) {
    data && this.setData(data, '');
  }

  ngOnInit(): void {
  }

  setData(d: any, url: string) {

    if (d.url) {
      this.url = d.url;
      return;
    }

    if (d?.orderId) {
      this.id = d.orderId;
    }

    this.url = '/montage/documents/' + this.id;

    if (d?.id) {
      this.url += '/' + d.id;
    }

    if (url) {
      this.url = url;
    }
    if(d.url) {
      this.url = d.url;
    }
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    const d = params?.data;
    this.setData(d, params?.colDef?.cellRendererParams?.url);
  }
}
